import { Col, Container, Row } from "reactstrap";

const Description = () => {
  return (

          <Col lg={12} className="section" id="description">
            <div className="text-center w-75 mx-auto">
              <p className="user-review">
                <span className="fw-bold">TAFE International Western Australia (TIWA)</span>,
                  adalah penyedia pendidikan vokasi terkemuka di Perth, Australia, yang 
                  dioperasikan oleh Pemerintah Western Australia. Dikenal dengan pendekatan 
                  praktis dan hands-on, TIWA menawarkan lebih dari 100 sertifikat yang 
                  diakui secara nasional. Institusi ini menyediakan jalur langsung ke 
                  universitas terkemuka seperti Universitas Western Australia 
                  (peringkat QS #77) dan Universitas Curtin (peringkat QS #174), 
                  membekali mahasiswa dengan keterampilan dan pengalaman yang 
                  diperlukan untuk sukses dalam karir lokal maupun global. 
              </p>
            </div>
          </Col>

  );
};

export default Description;